import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import { useEffect, useState } from 'react';
import Input from "../../../../Core/Fields/Floating/Input";

const EditItemModal = ({ tabData, show, onClose, itemDataReal, onChange, full_Item_Detail }) => {
  const { data: current_item } = useGetDoctypeDetailsQuery({ "doctype": "Item", "name": itemDataReal?.item_code });
  const [itemData, setitemData] = useState({});
  useEffect(() => {
    setitemData(itemDataReal);
  }, [itemDataReal])


  if (!show || !itemData) return null;

  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...itemData, [name]: value });
  };



  const handleRemoveSerial = (serial) => {
    onChange(serial);
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: 'none' }}>
            <h5 className="modal-title">Edit Item</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="row mb-2">
              <div className="col-6">
                <Input id="po_no" label="PO No." readOnly value={tabData.po} style={{ height: "30px" }} />
              </div>
              <div className="col-6">
                <Input id="supplier" label="Supplier" readOnly value={tabData.supplier} style={{ height: "30px" }} />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <Input id="item_name" label="Item Name" readOnly value={full_Item_Detail.item_name} style={{ height: "30px" }} />
              </div>
              <div className="col-6">
                <Input id="item_code" label="Item Code" readOnly value={full_Item_Detail.item_code} style={{ height: "30px" }} />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <Input id="rate" label="Rate" readOnly value={full_Item_Detail.amount} style={{ height: "30px" }} />
              </div>
              <div className="col-6">
                <Input id="uom" label="UOM" readOnly value={full_Item_Detail.uom} style={{ height: "30px" }} />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <Input id="total_qty" label="Total Qty" readOnly value={full_Item_Detail.grn_qty} style={{ height: "30px" }} />
              </div>
              <div className="col-6">
                <Input id="expiry_date" label="Expiry Date" name="expiry_date" value={itemData.expiry_date || ""} style={{ height: "30px" }} onChange={handleInput} />
              </div>
            </div>

            {current_item?.message?.has_serial_no === 1 && (
              <>
                <div className="row mb-3">
                  <div className="col-6">
                    <Input
                      id="batch_no"
                      label="Batch No."
                      name="batch_no"
                      value={itemData.batch_no || ""}
                      style={{ height: "30px" }}
                      onChange={handleInput}
                    />
                  </div>

                  <div className="col-6">
                    <div className="mb-2 position-relative">
                      <label
                        htmlFor="serialBox"
                        className="position-absolute"
                        style={{
                          top: '-10px',
                          left: '12px',
                          backgroundColor: '#fff',
                          padding: '0 5px',
                          fontSize: '0.75rem',
                          color: '#6c757d',
                          zIndex: 1,
                        }}
                      >
                        Scanned Serial Numbers
                      </label>
                      <div
                        id="serialBox"
                        className="form-control"
                        style={{
                          height: '150px',
                          overflowY: 'auto',
                          fontSize: '0.8rem',
                          borderRadius: '10px',
                          // backgroundColor: '#f8f9fa',
                        }}
                      >
                        {itemData.serial_no_used?.length > 0 ? (
                          <div className="row g-2">
                            {itemData.serial_no_used.map((serial, index) => (
                              <div className="col-6 mt-3" key={index}>
                                <div
                                  className="d-flex justify-content-between align-items-center  px-2 py-1 border rounded-pill"
                                  style={{ fontSize: '0.75rem', lineHeight: '1.2', backgroundColor: '#EDEDED' }}
                                >
                                  <span
                                    className="text-truncate"
                                    style={{ maxWidth: '85%', overflow: 'hidden', whiteSpace: 'nowrap', color: '#555' }}
                                  >
                                    {index + 1}. {serial}
                                  </span>
                                  <button

                                    onClick={() => handleRemoveSerial(serial, index)}
                                    type="button"
                                    className="px-1"
                                    style={{
                                      paddingTop: '0px',
                                      paddingBottom: '4px',
                                      width: '13px',
                                      height: '13px',
                                      background: 'white',
                                      border: 'none',
                                      color: 'black',
                                      fontSize: '10px',
                                      borderRadius: '50%',
                                      cursor: 'pointer',

                                    }}
                                  >
                                    ×
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-muted text-center pt-4">No serial numbers scanned yet</div>
                        )}
                      </div>
                      <div className="text-end mt-1" style={{ fontSize: '0.75rem' }}>
                        Total: {itemData.serial_no_used?.length || 0} serial numbers
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>


        </div>
      </div>
    </div>

  );
};

export default EditItemModal;